// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2A2Qk","content":"styles_content__AbOjP","row":"styles_row__AvcHL","footer":"styles_footer__3YWsf","phraseLength":"styles_phraseLength__16yWI"};